export { default as OrderDetail } from "./OrderDetail";

